<div class="w-14rem h-full surface-100 shadow-1 lg:block hidden overflow-auto">
  <app-user-tag />
  <app-menu-items />
</div>
